import axios from "axios";
import { useUserStore } from "@/stores/userStore";
import { computed } from "vue";
import cartServices from "@/services/cartServices";
import orderServices from "@/services/orderServices";
import addressServices from "@/services/addressServices";
import { useCartStore } from "@/stores/cart";
// import { showToast } from "@/utils/toaster";
import OffersAndPointsServices from "@/services/OffersAndPointsServices";

export default function useAuthenticatedApi() {
    const userStore = useUserStore();
    const cartStore = useCartStore();
    const accessToken = computed(() => userStore.getAccessToken);
    const refreshToken = computed(() => userStore.getRefreshToken);
    const modicareAccessToken = computed(() => userStore.modicareAccessToken);
    function clearData(){
        userStore.destroySession();
        cartStore.clearCart()
        cartStore.destroyCart();
        window.location.href='/';
        // showToast('loggedOut');
    }

    const axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        headers: {
            'Content-Type': 'application/json',
        }
    });
    axiosInstance.interceptors.request.use(config => {
        const token = accessToken.value;
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            // config.headers['x-rm'] = `MW`;
        }
        return config;
    }, error => {
        return Promise.reject(error);
    });

    axiosInstance.interceptors.response.use(response => {
        return response;
    }, async (error) => {
        if (error.response && error.response.status === 401) {
           try {
            console.log(refreshToken.value)
                const response = await axios.post(
                process.env.VUE_APP_BASE_API_URL + "/users/refresh-token",{
                    refreshToken: refreshToken.value,
                });
                if (response.data.accessToken) {
                    userStore.setAccessToken(response.data.accessToken);
                    userStore.setRefreshToken(response.data.refreshToken);
                } else {
                    clearData()
                }
                console.log(response.data)
            } catch (error) {
                console.error("Error refreshing token:", error);
                clearData()
            }
        }
        return Promise.reject(error);
    });



    const MdiaxiosInstance = axios.create({
        baseURL: process.env.VUE_APP_BASE_MODICARE_API_URL,
        headers: {
            'Content-Type': 'application/json',
        }
    });
    MdiaxiosInstance.interceptors.request.use(config => {
        if (modicareAccessToken.value) {
            config.headers['x-auth-token'] = `${modicareAccessToken.value}`;
            // config.headers['x-rm'] = `MW`;
        }
        return config;
    }, error => {
        return Promise.reject(error);
    });
    const cartService = cartServices(axiosInstance);
    const orderService = orderServices(MdiaxiosInstance);
    const addressService = addressServices(axiosInstance);
    const offerService = OffersAndPointsServices(MdiaxiosInstance);

    return {
        axios: axiosInstance,
        Maxios: MdiaxiosInstance,
        cartService,
        orderService,
        addressService,
        offerService,
    }
}